export const isNumber = (value: any) => {
  return typeof value === 'number' && !isNaN(value);
};

export const setDb = (num: number) => {
  if (num < 10) {
    return '0' + num;
  } else {
    return '' + num;
  }
};

export function formatTimetoString(time: number) {
  const hour = setDb(Math.floor((time % 86400000) / 3600000));
  const minutes = setDb(Math.floor((time % 3600000) / 60000));
  const seconds = setDb(Math.floor((time % 60000) / 1000));
  const timeLong1 = hour + ':' + minutes + ':' + seconds;
  return timeLong1;
}

export function formatCountdown(remainingSeconds: number) {
  if (remainingSeconds <= 0) {
    // 处理超时状态
    const timeoutSeconds = -remainingSeconds;
    const mins = Math.floor(Math.floor((timeoutSeconds % 3600000) / 60000));
    const secs = Math.floor((timeoutSeconds % 60000) / 1000);
    return `超时${mins}分${String(secs).padStart(2, '0')}秒`;
  }
  
  const mins = Math.floor((remainingSeconds % 3600000) / 60000);
  const secs = Math.floor((remainingSeconds % 60000) / 1000);

  // 处理正常倒计时状态
  if (remainingSeconds < 60000) {
    return '1分钟后完成';
  } else if (secs === 0) {
    return `${mins}分钟后完成`;
  } else {
    return `${mins + 1}分钟后完成`;
  }
}
